import React, { useEffect, useState } from "react";
import StyledSelect from "../../../../components/generic/StyledSelect";
import { backendGetRequest } from "../../../../helpers/callBackend";
import Box from "@mui/material/Box";

/**
 *
 * @param {Function} setEntityId state setter for current entity object
 * @param {string} entityId current entity ID to set as default value
 * @returns Current user entities in a dropdown
 */
const AparEntitySelector = (props) => {
  const [entities, setEntities] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [loadingDone, setLoadingDone] = useState(false);

  const getEntities = async () => {
    // TODO: figure out why this backend request takes 0.8s even when only getting 2
    // entities from backend and 10s when getting a larger list
    let entResp = await backendGetRequest("/api/entity/");
    if (entResp.status != 200) {
      console.error("Error getting account entities");
    }
    setEntities(entResp.data.entities);
  };

  const onChange = (event) => {
    event.stopPropagation();
    localStorage.setItem("mercoa_entity_id", event.target.value);
    props.setEntityId(event.target.value);
  };

  useEffect(() => {
    getEntities();
  }, []);

  useEffect(() => {
    setLoadingDone(false);
    if (entities.length <= 0) {
      return;
    }
    let newItems = entities.map((entity) => {
      // Note: mercoa sessions cannot be passed a foreignId for entityId
      let entityId = entity.id;

      // if the entity has a mercoa id use that for querying
      if (entity.mercoa_entity_id) {
        entityId = entity.mercoa_entity_id;
      }

      return {
        display_text: entity.entity_info.name,
        value: entityId,
      };
    });
    setItemList(newItems);
    setLoadingDone(true);
  }, [entities]);

  useEffect(() => {
    props.setEntitiesLoaded(loadingDone);
  }, [loadingDone]);

  return (
    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", "mt": 1 }}>
      <StyledSelect
        label={props.entityId ? "" : "Please select an entity"}
        formWidth="30%"
        items={itemList}
        onChange={(event) => onChange(event)}
        value={itemList.length > 0 && props.entityId ? props.entityId : ""}
        disabled={!loadingDone}
      />
    </Box>
  );
};

export default AparEntitySelector;
